import React from 'react';
import { useGame } from '../context/GameContext.jsx';

const ToastMessage = () => {
  const { toastMessage, showToast } = useGame();

  if (!toastMessage && !showToast) {
    return null;
  }

  return (
    <div className={`toast-message-container ${showToast ? 'fade-in' : ''}`}>
      {toastMessage}
    </div>
  );
};

export default ToastMessage;
